<template>
  <div class="rush_good" :style="boxStyle">
        <div v-show="rushGoodList.length" v-for="(item,idx) in rushGoodList" :key="idx" class="rush_good_list">
            <div class="rush_time">
                <span class="time_num">{{item.hourTime?item.hourTime:"--"}}</span>
                <span class="colon">:</span>
                <span class="time_num">{{item.minuteTime?item.minuteTime:"--"}}</span>
                <span class="colon">:</span>
                <span class="time_num">{{item.secondTime?item.secondTime:"--"}}</span>
                <span class="time_txt" v-if="!item.noStart">后结束</span>
                <span class="time_txt" v-else>后开始</span>
            </div>
            <div class="rush_good_content">
                <div class="rush_good_img">
                    <div class="logo_tag" v-if="item.tagImages">
                        <img mode="aspectFit"  :src="item.tagImages" />
                    </div>
                    <img class="img" :src="item.showImg" />
                </div>
                <div class="rush_good_info">
                    <div class="title">{{item.name}}</div>
                    <div class="description"></div>
                    <!-- <div class="progress_bg">
                        <div class="progress_bgcolor public_bg"></div>
                        <div class="progress public_bg" v-if="!item.noStart" :style="`width:${((item.useAmount+item.initUseAmount)/(item.amount+item.initUseAmount))*100}%`"></div>
                        <div class="progress public_bg" v-else :style="`width:${(item.useAmount)/(item.amount)*100}%`"></div>
                        <div :class="['progress_txt',item.useAmount == item.amount && item.useAmount != 0?'saleDone':'']" v-if="!item.noStart">已售{{item.useAmount + item.initUseAmount}}</div>
                        <div class="progress_txt" v-else>库存{{item.amount-item.useAmount}}</div>
                    </div> -->
                    <div class="orgin_price" v-if="showOriginalPrice"><span>原价：¥{{item.originalPrice}}</span></div>
                    <div class="rush_price"><span>抢购价</span><span class="symbol red">¥</span><span class="price red">{{(item.newCustPrice && localInviteId && isNewMember) ? item.newCustPrice : item.price}}</span></div>
                    <div class="rush_btn public_bg" v-if="item.onReservation">立即预约</div>
                    <div class="rush_btn rush_btn1" v-else-if="item.noStart">未开始</div>
                    <div class="rush_btn rush_btn1" v-else-if="item.amount <= item.useAmount">已售罄</div>
                    <div class="rush_btn rush_btn1" v-else-if="item.rushEnd">已结束</div>
                    <div class="rush_btn public_bg" v-else-if="item.createdDone">立即抢购</div>
                </div>
            </div>
        </div>
        <div v-show="!rushGoodList.length" class="defaultImg"></div>
    </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'rushGood',
  mixins: [mixins],
  props: {
    user: {
      type: Object,
      default: ()=>{}
    },
  },
  components: {},
  data() {
    return {
      rushGoodList:[], // 抢购商品
      localInviteId: "",
      intervalSta: null,
      pattern: {},
    }
  },
  computed: {
    isNewMember() {
      return true
    },
    showOriginalPrice() {
      return true;
    },
    boxStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
      }
    },
  },
  methods: {
    rushGoodData(data) {
        console.log("抢购商品",data);
        if(!data || data.length == 0) return;
        var ts=new Date().getTime();
        data.forEach(element => {
            console.log("抢购商品element",element);
            var countdown = null;
            if(element.useAmount < 0) element.useAmount = 0;
            let reservationEndTime = (element.reservationEndTime || 0) * 60000;
            if(element.saleprop == 1 && element.reservationFlag && (element.startTime - reservationEndTime > ts)){
                element.onReservation = true;
            }
            if(element.endTime - ts > 0 && element.amount != element.useAmount) {
                if(element.startTime > ts) {
                    element.noStart = true;
                    countdown = element.startTime - ts;
                    element.hourTime = this.changeTime("hour",countdown);
                    countdown = countdown % 3600000;
                    element.minuteTime = this.changeTime("minute",countdown);
                    countdown = countdown % 60000;
                    element.secondTime = this.changeTime("second",countdown);
                } else {
                    element.noStart = false;
                    countdown = element.endTime - ts;
                    element.hourTime = this.changeTime("hour",countdown);
                    countdown = countdown % 3600000;
                    element.minuteTime = this.changeTime("minute",countdown);
                    countdown = countdown % 60000;
                    element.secondTime = this.changeTime("second",countdown);
                }
            } else {
                element.hourTime = "00";
                element.minuteTime = "00";
                element.secondTime = "00";
                element.rushEnd = true;
            }
            let images = element.images.split(',');
            element.showImg = this.getPicture('mall', {
                file: images[0],
                type: 'mall',
                size: 's',
                options: {
                    parentShopId: this.tenantId
                }
            });
            if (element.tagImages && element.tagImages.indexOf('https') === -1 ) {
                element.tagImages = this.getPicture('tagImages', {
                    file: element.tagImages
                });
            }
            element.createdDone = true;
        })
        this.rushGoodList = data;
        // this.intervalSta = null
        // clearInterval(this.intervalSta);
        // this.intervalSta = setInterval(() => {
        //     var ts=new Date().getTime();
        //     data.forEach(element => {
        //         console.log("抢购商品element",element);
        //         var countdown = null;
        //         if(element.useAmount < 0) element.useAmount = 0;
        //         let reservationEndTime = (element.reservationEndTime || 0) * 60000;
        //         if(element.saleprop == 1 && element.reservationFlag && (element.startTime - reservationEndTime > ts)){
        //             element.onReservation = true;
        //         }
        //         if(element.endTime - ts > 0 && element.amount != element.useAmount) {
        //             if(element.startTime > ts) {
        //                 element.noStart = true;
        //                 countdown = element.startTime - ts;
        //                 element.hourTime = this.changeTime("hour",countdown);
        //                 countdown = countdown % 3600000;
        //                 element.minuteTime = this.changeTime("minute",countdown);
        //                 countdown = countdown % 60000;
        //                 element.secondTime = this.changeTime("second",countdown);
        //             } else {
        //                 element.noStart = false;
        //                 countdown = element.endTime - ts;
        //                 element.hourTime = this.changeTime("hour",countdown);
        //                 countdown = countdown % 3600000;
        //                 element.minuteTime = this.changeTime("minute",countdown);
        //                 countdown = countdown % 60000;
        //                 element.secondTime = this.changeTime("second",countdown);
        //             }
        //         } else {
        //             element.hourTime = "00";
        //             element.minuteTime = "00";
        //             element.secondTime = "00";
        //             element.rushEnd = true;
        //         }
        //         let images = element.images.split(',');
        //         element.showImg = this.getPicture('mall', {
        //             file: images[0],
        //             type: 'mall',
        //             size: 's',
        //             options: {
        //                 parentShopId: this.tenantId
        //             }
        //         });
        //         if (element.tagImages && element.tagImages.indexOf('https') === -1 ) {
        //             element.tagImages = this.getPicture('tagImages', {
        //                 file: element.tagImages
        //             });
        //         }
        //         element.createdDone = true;
        //     })
        //     this.rushGoodList = data;
        // },1000)
    },
    changeTime(type,time_) {
        if(type == "hour") {
            return Math.floor(time_ / 3600000) > 9 ? Math.floor(time_ / 3600000) : "0" + Math.floor(time_ / 3600000);
        } else if(type == "minute") {
            return Math.floor(time_ / 60000) > 9 ? Math.floor(time_ / 60000) : "0" + Math.floor(time_ / 60000);
        } else if(type == "second") {
            return Math.floor(time_ / 1000) > 9 ? Math.floor(time_ / 1000) : "0" + Math.floor(time_ / 1000);
        }
    },
    async init() {
        let detailData = await this._filter(this.itemData)
        this.pattern = detailData.pattern || {}
        console.log("rushGood----------detailData");
        console.log(detailData);
        this.rushGoodData(detailData.rushGoodArr)
    }
  },
  beforeDestroy(){
    clearInterval(this.intervalSta);
    this.intervalSta = null
  },
  async mounted() {
    
  },
}
</script>
<style lang="scss" scoped>
    .rush_good {
        // width: 269px;
        .red{
            color: #eb637a;
        }
        .rush_good_list {
            position: relative;
            background-color: #fff;
            padding: 10px;
            margin-bottom: 1px;
            .rush_time {
                .time_num {
                    display: inline-block;
                    margin: 1px 0 10px;
                    background-color: #555;
                    color: #fff;
                    font-size: 14px;
                    font-weight: bold;
                    padding: 3px 5px;
                    border-radius: 2px;
                    min-width: 17px;
                    text-align: center;
                }
                .colon {
                    margin: 0 4px;
                    font-weight: bold;
                    color: #555;
                }
                .time_txt {
                    font-size: 12px;
                    color: #555;
                    margin-left: 10px;
                }
            }
            .rush_good_content {
                .rush_good_img {
                    display: inline-block;
                    width: 89px;
                    height: 89px;
                    overflow: hidden;
                    // border: 1rpx solid #DBDBDB;
                    margin-right: 10px;
                    margin-left: 1px;
                    border-radius: 6px;
                    position: relative;
                    .logo_tag{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 36px;
                        height: 36px;
                        z-index: 2;
                        font-size: 0;
                        img{
                            vertical-align: top;
                        }
                    }
                }
                .rush_good_info {
                    display: inline-block;
                    vertical-align: top;
                    .title {
                        width: 139px;
                        font-size: 14px;
                        color: #333;
                        font-weight: 600;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .description {
                        width: 139px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        font-size: 10px;
                        color: #999;
                        height: 10px;
                    }
                    .progress_bg {
                        position: relative;
                        width: 139px;
                        height: 13px;
                        border-radius: 11px;
                        overflow: hidden;
                        margin-top: 6px;
                        .progress_bgcolor {
                            width: 100%;
                            height: 100%;
                            opacity: 0.1;
                        }
                        .progress {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100px;
                            height: 11px;
                            border-radius: 11px;
                        }
                        .progress_txt {
                            position: absolute;
                            top: -1px;
                            right: 5px;
                            font-size: 10px;
                            color: #888;
                            &.saleDone {
                                color: #fff;
                            }
                        }
                    }
                    .orgin_price {
                        text-decoration:line-through;
                        font-size: 10px;
                        color: #C8C8C8;
                        margin-top: 15px;
                    }
                    .rush_price {
                        font-size: 11px;
                        color: #333;
                        margin-top: 2px;
                        .symbol {
                            font-size: 11px;
                        }
                        .price {
                            font-size: 16px;
                            font-weight: bold;
                        }
                    }
                    .rush_btn {
                        position: absolute;
                        right: 10px;
                        bottom: 16px;
                        color: #fff;
                        font-size: 12px;
                        padding: 4px 10px;
                        border-radius: 28px;
                        text-align: center;
                        background-color: #eb637a;
                        &.rush_btn1 {
                            background-color: #A1A1A1;
                        }
                    }
                }
            }
        }
        .defaultImg{
            width: 100%;
            height: 0;
            padding-top: 48%;
            background-image: url("../image/rushGood.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
    }
</style>
